import React from 'react';
import { ComCheckbox } from './components/index';
import { Box } from '../../../../common/components/index';
import MdEmail from 'react-icons/lib/md/email';
import MdPhoneIphone from 'react-icons/lib/md/phone-iphone';
import MdLaptopMac from 'react-icons/lib/md/laptop-mac';
import './Communications.scss';
import { Col, FormGroup } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import { isBroker } from '../../../auth/redux/authActions';

const getIcon = (type) => {
  if (type === 'email') {
    return <MdLaptopMac size={30} />;
  }
  if (type === 'sms') {
    return <MdPhoneIphone size={30} />;
  }
  if (type === 'post') {
    return <MdEmail size={30} />;
  }
  return <MdEmail size={40} />;
};
const Communications = ({
  meta,
  input,
  content,
  communicationTypes,
  onCommunicationOptionsChange,
}) => {
  const onCommunicationChange = (communicationType, value) => {
    const existingValues = input.value || {};
    const newValues = {
      ...existingValues,
      [communicationType]: value,
    };
    input.onChange(newValues);
    if (onCommunicationOptionsChange) {
      onCommunicationOptionsChange(value, communicationType);
    }
  };

  return (
    <Box className="comms-container">
      <FormGroup>
        <Col sm={12}>
          <h4>{isBroker() ? 'Policy Confirmation' : 'Sending Policy Documents'} </h4>
          <ReactMarkdown source={content['header']} />
        </Col>
      </FormGroup>

      {communicationTypes.map((communicationType) => (
        <ComCheckbox
          key={communicationType}
          value={input?.value?.[communicationType]}
          labelSize={10}
          label={
            <div className={'communication-label'}>
              <div>{getIcon(communicationType)}</div>
              <div>
                <ReactMarkdown
                  source={content['communication_types'][communicationType]}
                />
              </div>
            </div>
          }
          communicationType={communicationType}
          onCommunicationChange={onCommunicationChange}
        />
      ))}
      {content['footer'] && <ReactMarkdown source={content['footer']} />}
      <br />

      {meta && meta.error && <span> {meta.error} </span>}
    </Box>
  );
};
export default Communications;
